import axios from "axios";

const BASE_API_URL = "/api/function";

class FunctionService {
  //一次拿 categories（events 內嵌在每個 category 底下）
  //  回傳：{ categories: [{ ...category, events: [...] }] }
  //  空類別會保留，events: []（前端 filter 隱藏 tab）
  getQimenMeta() {
    return axios.post(BASE_API_URL + "/qimen-meta", {});
  }

  //奇門盤面（F-1）
  caluQimenPlate({ date, landTime, type, defaultNow }) {
    return axios.post(BASE_API_URL + "/calu-qimenplate", {
      date,
      landTime,
      type,
      defaultNow,
    });
  }

  //找吉時／吉日（F-3）
  //  plateType === "1"（時盤）: { eventId, date }
  //  plateType === "2"（日盤）: { eventId, startDate, endDate }
  findLuckyTimes(payload) {
    return axios.post(BASE_API_URL + "/find-lucky-times", payload);
  }
}

export default new FunctionService();
